<!-- navItem „Runs/Deckung“ — Deckungsverlauf der Rücklage je Provisionslauf inkl. shortfallAmount. -->
<div class="cp-provision-agent-reserve-coverage">

    @if (!initialized) {
        <p-skeleton height="16rem"></p-skeleton>
    } @else if (!provisionAgentId) {
        <p-message severity="info" text="Kein Abrechnungskonto ausgewählt." styleClass="w-full"></p-message>
    } @else if (reserveCoverageWidget) {
        <mvs-widget #reserveCoverageWidgetRef [widgetData]="reserveCoverageWidget"></mvs-widget>
    }

</div>
